import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import SystemMessage from 'portal-modules/common/components/SystemMessage'
import RpModal from './rp-modal'
import { getLocale } from 'portal-modules/common/utils/language-details'
import { connect } from 'react-redux'
import {
  saveAccountSettings,
  requestAccountSettings,
} from 'portal-modules/settings/redux/modules/accountSettings'
import {
  setLoading,
  unsetLoading,
} from 'portal-modules/common/redux/modules/loading'
import {
  setTokenDetailsInCookie
} from 'portal-modules/auth/redux/modules/user'
import {
  IS_COOKIE_FUNCTIONALITY_ENABLED,
  RP_SESSION_COOKIE_DELETED
} from 'portal-modules/common/constants/keys'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()
import { localStorage as local } from '@entrata/utils'
import styled from '@emotion/styled'

const StyledButton = styled(Button)`
  min-width: 100%;
  font-size: 16px;
  line-height: 1.5;
  margin: 0 4px 16px;
`

const UpdateLanguageModal = props => {
  const [error, setError] = useState(null)
  const [show, setShow] = useState(true)

  const hideModal = () => {
    setShow(false)
  }

  useEffect(() => {
    if (!props.propertyLeaseViewPreference) {
      IS_COOKIE_FUNCTIONALITY_ENABLED && isRP ? props.setTokenDetailsInCookie({
        id: props.leaseId,
        type: 'lease',
        delete_cookies: true,
      }, () => {
        props.requestAccountSettings()
        local.set(RP_SESSION_COOKIE_DELETED, true);
      }) : props.requestAccountSettings()
    }
  }, [])

  const handleCancel = () => {
    // Keep the track of cancel action so that we can avoid showing popup on page refresh
    // Will clear this value on logout success
    if (typeof Storage !== 'undefined') {
      localStorage.setItem('locale_update_cancelled', true)
    }
    hideModal()
    props.onClick()
  }

  const handleUpdate = () => {
    const requestAccountSettingsCall = () => {
      props.saveAccountSettings({
        payload: {
          language_preference: getLocale().locale,
          property_lease_view_preference: props.propertyLeaseViewPreference,
        },
      })
    }

    try {
      setError(null)
      props.setLoading({ key: 'modal', message: __('Saving') })
      if (isRP && IS_COOKIE_FUNCTIONALITY_ENABLED) {
        props.setTokenDetailsInCookie({
          id: props.leaseId,
          type: 'lease',
          delete_cookies: true,
        }, () => {
          requestAccountSettingsCall()
          local.set(RP_SESSION_COOKIE_DELETED, true);
        })
      } else {
        requestAccountSettingsCall()
      }
      
      
    } catch (error) {
      setError(__('There was an error in saving preferred language.'))
      props.unsetLoading({ key: 'modal' })
    }
  }

  return (
    <RpModal
      show={show}
      onClose={hideModal}
      title={__('Update Language')}
      footerContent={
        <Fragment>
          <StyledButton appearance='primary' onClick={handleUpdate}>
            {__('Update Language')}
          </StyledButton>
          <StyledButton appearance='secondary' onClick={handleCancel}>
            {__('No Thanks')}
          </StyledButton>
        </Fragment>
      }
    >
      {error && <SystemMessage type='error'>{error}</SystemMessage>}
      <span>
        {__(
          'You have selected a new language on login. Would you like to update your preferred language to {%s, 0}? You can change this perference from the settings section.',
          [getLocale().language],
        )}
      </span>
    </RpModal>
  )
}

UpdateLanguageModal.propTypes = {
  onClick: PropTypes.func.isRequired,
  saveAccountSettings: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  unsetLoading: PropTypes.func.isRequired,
  propertyLeaseViewPreference: PropTypes.object,
  requestAccountSettings: PropTypes.func.isRequired,
  setTokenDetailsInCookie: PropTypes.func.isRequired,
  leaseId: PropTypes.number,
}

export default connect(
  ({ accountSettings, user }) => ({
    propertyLeaseViewPreference: accountSettings.property_lease_view_preference,
    leaseId: user.lease_id,
  }),
  { saveAccountSettings, setLoading, unsetLoading, requestAccountSettings, setTokenDetailsInCookie },
)(UpdateLanguageModal)
